
<div class="cat-journey">
    <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-11">
            <div class="cat-journey-header-text text-center desktop-show">
              <h1>Best <span>CAT Coaching</span> in  {{pageType}} 2025</h1>
              <h6>with iQuanta!</h6>
            </div>
            <div class="cat-journey-wrapper">
    
              <div class="cat-journey-bg">
                <img class="desktop-show" src="https://media.iquanta.in/ui_images/cat-journey-bg.png" alt="">
                <img class="mobile-show" src="https://media.iquanta.in/ui_images/cat-journey-bg-mobile.png" alt="">
              </div>
              <div class="cat-jounrey-wrapper">
                <div class="cat-jounrey-single-wrapper">
                  <div class="row">
                    <div class="col-md-3 col-12">
                      <div class="person text-center desktop-show">
                        <h4>Start CAT Journey</h4>
                        <div class="img" *ngIf="!userData?.profile_pic_url">
                          <img src="https://media.iquanta.in/ui_images/Indra.png" alt="">
                        </div>
                        <div class="img">
                          <div class="userDropIcon1" *ngIf="userData?.profile_pic_url"
                          [ngStyle]="{'background':'url('+userData?.profile_pic_url+')'}">
                        </div>
                        </div>
                       
                        <h5>CAT 2025 Aspirant</h5>
                      </div>
    
                      <div class="mobile-show person-mobile">
    
                        <div class="row">
                          <div class="col-6">
                            <div class="person text-center ">
                              <div class="img" *ngIf="!userData?.profile_pic_url  && (!userData?.gmail_pic) ">
                                <img src="https://media.iquanta.in/ui_images/Indra.png" alt="">
                              </div>
                              <div class="img">
                                <div class="userDropIcon1" *ngIf="userData?.profile_pic_url || userData?.gmail_pic"
                                [ngStyle]="{'background':'url('+userData?.profile_pic_url ? userData?.profile_pic_url : userData?.gmail_pic+')'}">
                              </div>
                              </div>
                            </div>
    
                          </div>
    
    
                          <div class="col-6 pl-0">
                            <div class="cat-journey-header-text text-center">
                              <h2>No.1 CAT
                                <span>Coaching</span>
                                in {{pageType}}
                              </h2>
                              <h6>700+ 99%ilers<br>in CAT</h6>
                            </div>
                          </div>
                        </div>
                      </div>
    
                    </div>
                    <div class="col-md-3">
                      <div class="cat-jounrey-single-item journey-position1" data-aos="fade-zoom-in"
                        data-aos-easing="ease-in-back" data-aos-delay="500" data-aos-offset="0">
                        <!-- <div class="cat-journey-single-card" (mouseover)="openStepFour('step1')"> -->
                        <div class="cat-journey-single-card" (click)="scrollTo('0')" style="cursor: pointer;">
                          <div class="cjs-in">
                            <div class="hover-card">
                              <div class="number">1</div>
                              <div class="text">
                                <h4>WHY MBA?</h4>
                                <ul class="nav">
                                  <li>1. High Salary</li>
                                  <li>2. Better Role</li>
                                  <li>3. Better Growth</li>
                                </ul>
                              </div>
                              <div class="more-button">
                                <button mat-button (click)="scrollTo('0')">More Details</button>
                              </div>
                            </div>
                           
                            <div class="img-element">
                              <img src="https://media.iquanta.in/ui_images/question-mark.png" alt="">
                            </div>
                            <div class="footer-button">
                              <button mat-button (click)="enquiryForm()">Get Counselling</button>
                            </div>
                          </div>
                        </div>
    
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="cat-jounrey-single-item journey-position2" data-aos="fade-zoom-in"
                        data-aos-easing="ease-in-back" data-aos-delay="1000" data-aos-offset="0">
                        <!-- <div class="cat-journey-single-card"  (mouseover)="openStepFour('step2')"> -->
                        <div class="cat-journey-single-card" (click)="scrollTo('1')" mat-button style="cursor: pointer;">
                          <div class="cjs-in">
                            <div class="number">2</div>
                            <div class="text-element">
                              What cat?
                            </div>
                            <div class="text">
                              <h4>CAT 2025 Details</h4>
                              <ul class="nav">
                                <li>1. Top B-Schools</li>
                                <li>2. Syllabus & Weightage</li>
                                <li>3. Important Dates</li>
                              </ul>
                            </div>
                            <div class="img-element">
                              <img src="https://media.iquanta.in/ui_images/cap.png" alt="">
                            </div>
                            <div class="footer-button">
                              <button (click)="scrollTo('1')" mat-button>Check Now</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="cat-jounrey-single-item journey-position3" data-aos="fade-zoom-in"
                        data-aos-easing="ease-in-back" data-aos-delay="1500" data-aos-offset="0">
                        <!-- <div class="cat-journey-single-card" (mouseover)="openStepFour('step3')"> -->
                        <div class="cat-journey-single-card">
                          <div class="cjs-in">
                            <div class="number">3</div>
                            <div class="text-element">
                              How
                            </div>
                            <div class="text">
                              <h4>CAT Strategy</h4>
                              <div class="cat-strategy-btns">
                                <button (click)="scrollToStrattegy('0')" class="btnbig" mat-button>Overall</button>
                                <div class="d-flex">
                                  <button (click)="scrollToStrattegy('3')" class="btnbig" mat-button>QA</button>
                                  <button (click)="scrollToStrattegy('1')" mat-button>VARC</button>
                                  <button (click)="scrollToStrattegy('2')" mat-button>LRDI</button>
                                </div>
                              </div>
                            </div>
                            <div class="img-element">
                              <img src="https://media.iquanta.in/ui_images/chess.png" alt="">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
    
    
                  <div class="row flex-column-reverse flex-sm-row">
                    <div class="col-md-3">
                      <div class="cat-jounrey-single-item journey-position5" data-aos="fade-zoom-in"
                        data-aos-easing="ease-in-back" data-aos-delay="3500" data-aos-offset="0">
                        <div class="cat-journey-single-card">
                          <div class="cjs-in">
                            <div class="number">7</div>
                            <div class="text-element">
                              Step 3
                            </div>
                            <div class="text">
                              <h4>Clear<br>
                                Doubts<br>
                                24*7</h4>
                            </div>
                            <div class="img-element">
                              <img src="https://media.iquanta.in/ui_images/user-check.png" alt="">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="cat-jounrey-single-item journey-position6" data-aos="fade-zoom-in"
                        data-aos-easing="ease-in-back" data-aos-delay="3000" data-aos-offset="0">
                        <div class="cat-journey-single-card">
                          <div class="cjs-in">
                            <div class="number">6</div>
                            <div class="text-element">
                              Step 2
                            </div>
                            <div class="text">
                              <h4>Practice</h4>
                              <ul class="nav">
                                <li>1. Application Classes</li>
                                <li>2. Assignment</li>
                                <li>3. Practice Session</li>
                                <li>4. Exclusive Material</li>
                                <li>5. IIM ABC Batch</li>
                              </ul>
                            </div>
                            <div class="img-element">
                              <img src="https://media.iquanta.in/ui_images/pencil.png" alt="">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="cat-jounrey-single-item journey-position7" data-aos="fade-zoom-in"
                        data-aos-easing="ease-in-back" data-aos-delay="2500" data-aos-offset="0">
                        <div class="cat-journey-single-card">
                          <div class="cjs-in">
                            <div class="number">5</div>
                            <div class="text-element">
                              Step 1
                            </div>
                            <div class="text">
                              <h4>Clear <br>
                                Concepts</h4>
                              <ul class="nav">
                                <li>1. Live Classes</li>
                                <li>2. Application Classes</li>
                                <li>3. Concept Videos</li>
                                <li> 4. Text Notes</li>
                              </ul>
                            </div>
                            <div class="img-element">
                              <img src="https://media.iquanta.in/ui_images/bulb.png" alt="">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="cat-jounrey-single-item journey-position8" data-aos="fade-zoom-in"
                        data-aos-easing="ease-in-back" data-aos-delay="2000" data-aos-offset="0">
                        <!-- <div class="cat-journey-single-card" (mouseover)="openStepFour('step4')"> -->
                        <div class="cat-journey-single-card">
                          <div class="cjs-in">
                            <div class="number">4</div>
                            <div class="text-element">
                              with
                            </div>
                            <div class="text">
                              <h4>iQuanta <br>
                                CAT Course</h4>
                              <ul class="nav">
                                <li>1. Concept Video</li>
                                <li>2. Live Classes</li>
                                <li>3. Rigorous Practice</li>
                                <li>4. 24*7 Doubt Solving</li>
                              </ul>
    
                              <h6>Step 1 to Final Lap: All<br>
                                included in CAT 2025 Course</h6>
                            </div>
                           
                            <div class="img-element">
                              <img src="https://media.iquanta.in/ui_images/book.png" alt="">
                            </div>
                            <div class="position-text">
                              CAT 2025<br>
                              Course Starts
                            </div>
                            <div class="footer-button">
                              <button mat-button (click)="gotocourse()">Enrol Now</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
    
                      <div class="cat-jounrey-single-item journey-position9" data-aos="fade-zoom-in"
                        data-aos-easing="ease-in-back" data-aos-delay="4000" data-aos-offset="0">
                        <div class="cat-journey-single-card">
                          <div class="cjs-in">
                            <div class="number">8</div>
                            <div class="text-element">
                              India’s First AI Mock
                            </div>
                            <div class="text">
                              <h4>iCAT Mock</h4>
                              <ul class="nav">
                                <li>1. 20 Full Mocks</li>
                                <li>2. 45 Sectional Mocks</li>
                                <li>3. AI Based Analysis</li>
                              </ul>
                            </div>
                            <div class="footer-button">
                              <button (click)="imock()" mat-button>Attempt Now</button>
                            </div>
                            <div class="img-element">
                              <img src="https://media.iquanta.in/ui_images/notepad.png" alt="">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="cat-jounrey-single-item journey-position10" data-aos="fade-zoom-in"
                        data-aos-easing="ease-in-back" data-aos-delay="4500" data-aos-offset="0">
                        <div class="cat-journey-single-card">
                          <div class="cjs-in">
                            <div class="number">9</div>
                            <div class="text-element">
                              Final Lap!
                            </div>
                            <div class="text">
                              <h4>CAT Crash Course</h4>
                              <ul class="nav">
                                <li>1. Revision & Shortcuts</li>
                                <li>2. Rigorous Practice</li>
                                <li>3. Important Initiatives</li>
                              </ul>
                            </div>
                            <div class="img-element">
                              <img src="https://media.iquanta.in/ui_images/clock.png" alt="">
                            </div>
                            <div class="jorney-footer-text">
                              Take CAT <br> land into IIMS
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="cat-jounrey-single-item journey-position11" data-aos="fade-zoom-in"
                        data-aos-easing="ease-in-back" data-aos-delay="5000" data-aos-offset="0">
                        <div class="cat-journey-single-card" (click)="playVideo()" style="cursor: pointer;">
                          <div class="cjs-in">
                            <div class="text">
                              <h4>¡Quanta Toppers who<br>
                                followed same Path</h4>
                            </div>
    
                            <div class="journey-video">
                              <img src="https://media.iquanta.in/ui_images/jurny-video.png" alt="">
                            </div>
    
                            <div class="footer-button">
                              <button (click)="playVideo()" mat-button>Their Feedback</button>
                            </div>
    
    
                            <div class="arrow" data-aos="fade-right" data-aos-duration="1000">
                              <img src="https://media.iquanta.in/ui_images/arrow.png" alt="">
                            </div>
    
    
                            <div class="jorney-footer-text">
                              Take CAT <br> land into IIMS
                            </div>
    
                          </div>
                        </div>
    
                      </div>
                    </div>
                  </div>
                </div>
              </div>
    
            </div>
          </div>
        </div>
      </div>
      <div class="cat-jorney-collages">
        <img class="desktop-show" src="https://media.iquanta.in/ui_images/cat-journey-collage.png" alt="">
        <img class="mobile-show" src="https://media.iquanta.in/ui_images/cat-journey-collage-mobile.png" alt="">
      </div>
</div>

